import { useEffect, useState } from "react";
import { getAdminTeamMembers, deleteTeamMember } from "../api/team.api";
import { Link } from "react-router-dom";

export default function TeamList() {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    const load = async () => {
      const data = await getAdminTeamMembers();
      setMembers(data);
    };
    load();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this member?")) {
      await deleteTeamMember(id);
      setMembers(members.filter(m => m.id !== id));
    }
  };

  return (
    <div className="container py-5">
      <h2>Team Management</h2>
      <Link to="/admin/team/add" className="btn btn-success mb-3">Add Member</Link>
      <table className="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Position</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {members.map(m => (
            <tr key={m.id}>
              <td>{m.name}</td>
              <td>{m.category}</td>
              <td>{m.position}</td>
              <td>
                <Link to={`/admin/team/edit/${m.id}`} className="btn btn-sm btn-info">Edit</Link>{" "}
                <button onClick={() => handleDelete(m.id)} className="btn btn-sm btn-danger">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
